import { ApiClient } from "./client"
import Vue from "vue"

let client = new ApiClient("/api/")

export default {
  async newLabel(label) {
    try {
      await client.post("label", label)
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de créer le label " + JSON.stringify(label),
      })*/
      console.log(error)
    }
  },

  async newLabels(labels) {
    try {
      await client.post("labels", { labels: labels })
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de créer les labels " + JSON.stringify(labels),
      })*/
      console.log(error)
    }
  },

  async editLabel({ guid, label }) {
    try {
      await client.patch("label", { "guid": guid, "label": label })
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: `impossible de mettre à jour le label ${guid} ` + JSON.stringify(label),
      })*/
      console.log(error)
    }
  },

  async deleteLabel(guid) {
    try {
      await client.delete("label/" + guid)
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: `impossible de supprimer le label ${guid}`,
      })*/
      console.log(error)
    }
  },
}
